
// Keycloak / OIDC client configuration used by the frontend when redirecting
/* export const env = {
    production: false,
    apiUrl: 'http://localhost:2000/v0.1/api/simo/'
} */

export const keycloakConfig = {
  //baseUrl: 'http://localhost:8083', // Keycloak base URL dev (no trailing slash)
  baseUrl: 'https://auths.moderneticbenin.com', // Keycloak base URL prod (no trailing slash)
  //realm: 'ceb-realm', // dev
  realm: 'RD-SAMB-REALM',//prod
  clientId: 'frontend-rd-samb',
  responseType: 'code',
  scope: 'openid profile email'
};


// Production configuration (example)
export const env = {
  production: true,
  apiUrl: 'https://backend.rd.samb.moderneticbenin.com/v0.1/api/simo/'
};